import { Box, Stack, Typography } from '@mui/material';
import { formatHistoryTimestamp } from '@/features/operations/labels';
import { getQuotationStatusLabel } from '@/features/operations/quotationStatus';
import type { QuotationStatusHistoryEntry } from '@/features/operations/types';

export function StatusHistoryTimeline({ entries }: { entries: QuotationStatusHistoryEntry[] }) {
  if (!entries.length) {
    return null;
  }

  return (
    <Box>
      <Typography variant="overline" color="text.secondary">
        HISTORIAL DE ESTADO
      </Typography>
      <Stack component="ul" spacing={1} sx={{ listStyle: 'none', m: 0, p: 0, mt: 0.5 }}>
        {entries.map((entry) => (
          <Stack component="li" key={entry.id} spacing={0.25}>
            <Typography variant="body2">
              {entry.fromStatus
                ? `${getQuotationStatusLabel(entry.fromStatus)} → ${getQuotationStatusLabel(entry.toStatus)}`
                : `Solicitud creada · ${getQuotationStatusLabel(entry.toStatus)}`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {formatHistoryTimestamp(entry.createdAt)} ·{' '}
              {entry.changedBy ? entry.changedBy.fullName : 'Solicitud pública'}
            </Typography>
            {entry.reason ? (
              <Typography variant="caption" color="text.secondary">
                Motivo: {entry.reason}
              </Typography>
            ) : null}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
